<template>
  <div class="app-container">
    <!-- 搜索区域 -->
    <el-card shadow="never" class="filter-card">
      <el-form :inline="true" :model="queryParams" size="small" class="filter-form">
        <el-form-item label="女神ID">
          <el-input v-model="queryParams.uid" placeholder="请输入ID" clearable @keyup.enter.native="handleQuery" />
        </el-form-item>
        <el-form-item label="昵称">
          <el-input v-model="queryParams.nick" placeholder="请输入昵称" clearable @keyup.enter.native="handleQuery" />
        </el-form-item>
        <el-form-item label="统计日期">
          <el-date-picker v-model="dateRange" type="datetimerange" range-separator="至"
            start-placeholder="开始" end-placeholder="结束" value-format="yyyy-MM-dd HH:mm"
            :default-time="['00:00:00', '23:59:59']" @change="handleDateChange" />
        </el-form-item>
        <el-form-item label=" ">
          <el-switch v-model="onlineOnly" active-text="仅在线" @change="handleOnlineChange" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 表格 -->
    <el-card shadow="never" class="table-card">
      <el-table :key="tableKey" v-loading="listLoading" :data="list" border stripe
        highlight-current-row style="width: 100%;" @sort-change="handleSortChange">
        <el-table-column label="排名" type="index" align="center" width="55" />
        <el-table-column label="女神ID" prop="uid" align="center" width="100" />
        <el-table-column label="头像" align="center" width="70">
          <template slot-scope="{row}">
            <img v-if="row.avatar" :src="row.avatar" style="width: 40px; height: 40px; border-radius: 50%;">
            <img v-else src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png" style="width: 40px; height: 40px; border-radius: 50%;">
          </template>
        </el-table-column>
        <el-table-column label="昵称" prop="nick" align="center" width="120" />
        <el-table-column label="收益积分" prop="today_earn_integral" align="center" sortable="custom" width="110" />
        <el-table-column label="在线时长" prop="online_duration" align="center" sortable="custom" width="110">
          <template slot-scope="{row}">
            {{ formatDuration(row.online_duration) }}
          </template>
        </el-table-column>
        <el-table-column label="接通率" prop="today_call_answer_rate" align="center" sortable="custom" width="90">
          <template slot-scope="{row}">
            <span :class="getRateClass(row.today_call_answer_rate)">
              {{ row.today_call_answer_rate ? row.today_call_answer_rate + '%' : '--' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="1分钟通话率" prop="today_one_minute_call_rate" align="center" sortable="custom" width="130">
          <template slot-scope="{row}">
            <span :class="getRateClass(row.today_one_minute_call_rate)">
              {{ row.today_one_minute_call_rate ? row.today_one_minute_call_rate + '%' : '--' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="接通次数" prop="today_call_answer" align="center" sortable="custom" width="110" />
        <el-table-column label="呼叫次数" prop="today_call_total" align="center" sortable="custom" width="110" />
        <el-table-column label="平均通话时长" prop="today_avg_call_time" align="center" sortable="custom" width="130">
          <template slot-scope="{row}">
            {{ formatDuration(row.today_avg_call_time) }}
          </template>
        </el-table-column>
        <el-table-column label="总通话时长" prop="today_total_call_time" align="center" sortable="custom" width="130">
          <template slot-scope="{row}">
            {{ formatDuration(row.today_total_call_time) }}
          </template>
        </el-table-column>
        <el-table-column label="收到消息" prop="msg_received" align="center" sortable="custom" width="110" />
        <el-table-column label="发送消息" prop="msg_sent" align="center" sortable="custom" width="110" />
        <el-table-column label="注册时间" align="center" min-width="150">
          <template slot-scope="{row}">
            <span>{{ row.create_time }}</span>
          </template>
        </el-table-column>
      </el-table>

      <pagination v-show="total > 0" :total="total" :page.sync="queryParams.page"
        :limit.sync="queryParams.limit" @pagination="getList" />
    </el-card>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { postAction } from '@/api/user'

export default {
  name: 'GoddessRanking',
  components: { Pagination },
  data() {
    return {
      tableKey: 0,
      list: [],
      total: 0,
      listLoading: false,
      dateRange: [],
      onlineOnly: true,
      queryParams: {
        page: 1,
        limit: 10,
        uid: '',
        nick: '',
        startTime: '',
        endTime: '',
        sort_field: 'earn',
        sort_order: 'desc'
      }
    }
  },
  created() {
    this.setDefaultDateRange()
    this.getList()
  },
  methods: {
    async getList() {
      this.listLoading = true
      try {
        const p = {
          page: this.queryParams.page,
          limit: this.queryParams.limit,
          sort_field: this.queryParams.sort_field || 'earn',
          sort_order: this.queryParams.sort_order || 'desc',
          online_today: this.onlineOnly ? 1 : 0
        }
        if (this.queryParams.uid) p.uid = this.queryParams.uid
        if (this.queryParams.nick) p.nick = this.queryParams.nick
        if (this.queryParams.startTime) p.startTime = this.queryParams.startTime + ':00'
        if (this.queryParams.endTime) p.endTime = this.queryParams.endTime + ':00'

        const res = await postAction('/api/center/goddessList', p)
        if (res.code === 200) {
          this.list = res.data.data || []
          this.total = res.data.total || 0
        } else {
          this.$message.error(res.msg || '获取数据失败')
        }
      } catch {
        this.$message.error('获取数据失败，请稍后重试')
      } finally {
        this.listLoading = false
      }
    },
    handleOnlineChange() {
      this.handleQuery()
    },
    setDefaultDateRange() {
      const today = this.fmtDateTime(new Date(), false)
      const todayEnd = this.fmtDateTime(new Date(), true)
      this.dateRange = [today, todayEnd]
      this.queryParams.startTime = today
      this.queryParams.endTime = todayEnd
    },
    handleSortChange({ prop, order }) {
      const FIELD_MAP = {
        today_earn_integral: 'earn',
        online_duration: 'online_duration',
        today_call_total: 'call_count',
        today_call_answer: 'answer_count',
        today_call_answer_rate: 'answer_rate',
        today_one_minute_call_rate: 'one_minute_rate',
        today_avg_call_time: 'avg_call_time',
        today_total_call_time: 'total_call_time',
        msg_received: 'msg_received',
        msg_sent: 'msg_sent'
      }
      if (!order) {
        this.queryParams.sort_field = 'earn'
        this.queryParams.sort_order = 'desc'
      } else {
        this.queryParams.sort_field = FIELD_MAP[prop] || 'earn'
        this.queryParams.sort_order = order === 'ascending' ? 'asc' : 'desc'
      }
      this.getList()
    },
    handleQuery() {
      this.queryParams.page = 1
      this.getList()
    },
    handleDateChange(dates) {
      this.queryParams.startTime = dates?.[0] ? dates[0] + ':00' : ''
      this.queryParams.endTime = dates?.[1] ? dates[1] + ':00' : ''
      if (dates) this.handleQuery()
    },
    resetQuery() {
      this.dateRange = []
      this.queryParams = {
        page: 1, limit: 10, uid: '', nick: '',
        startTime: '', endTime: '',
        sort_field: 'earn', sort_order: 'desc'
      }
      this.onlineOnly = true
      this.setDefaultDateRange()
      this.getList()
    },
    fmtDateTime(date, isEnd) {
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      return isEnd ? `${y}-${m}-${d} 23:59` : `${y}-${m}-${d} 00:00`
    },
    fmtDate(date) {
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
    },
    formatDuration(seconds) {
      if (!seconds || seconds <= 0) return '--'
      const total = Math.round(Number(seconds))
      const h = Math.floor(total / 3600)
      const m = Math.floor((total % 3600) / 60)
      const s = total % 60
      return `${h}时${m}分${s}秒`
    },
    getRateClass(rate) {
      if (!rate) return ''
      if (rate >= 80) return 'rate-high'
      if (rate >= 50) return 'rate-mid'
      return 'rate-low'
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  padding: 16px;
}

.filter-card {
  margin-bottom: 16px;

  ::v-deep .el-card__body {
    padding: 16px 20px 0;
  }

  .filter-form {
    .el-form-item {
      margin-bottom: 16px;
    }
  }
}

.table-card {
  ::v-deep .el-card__body {
    padding: 0 20px 16px;
  }
}

.rate-high { color: #67c23a; font-weight: 600; }
.rate-mid  { color: #e6a23c; font-weight: 600; }
.rate-low  { color: #f56c6c; font-weight: 600; }

@media (max-width: 768px) {
  .app-container {
    padding: 8px;
  }

  .filter-card ::v-deep .el-card__body {
    padding: 12px 12px 0;
  }

  .table-card ::v-deep .el-card__body {
    padding: 0 8px 12px;
  }
}
</style>
